export enum OrderOriginEnum {
  CADOSTORE = 'CADOSTORE',
  CADOWEB = 'CADOWEB',
  BY_FILE = 'BY_FILE',
  PARTNER = 'PARTNER',
  BIMPLI = 'BIMPLI'
}
